export default __webpack_public_path__ + "static/media/025-ribbon.05ca3d19.svg";